import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//import { AppSpinnerComponent } from './path-to-app-spinner';
//const routes: Routes = [/* tus rutas */];

import { DragDropModule } from '@angular/cdk/drag-drop';
// import { ModuleWithProviders } from '@angular/core';
// import { TranslateModule } from '@ngx-translate/core';

//import { SpinnerModule } from '../spinner/spinner.module';
//import { ImageViewerModule } from 'ngx-image-viewer';
// Angular Material
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatStepperModule } from '@angular/material/stepper';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LightboxModule } from 'ng-gallery/lightbox';
import { Input } from '@angular/core';

// Nebular
import {
  NbThemeModule,
  NbLayoutModule,
  NbSidebarModule,
  NbButtonModule,
  NbContextMenuModule,
  NbBadgeModule,
  NbAccordionModule,
  NbCheckboxModule,
  NbCardModule,
  NbMenuModule,
  NbListModule,
  NbUserModule,
  NbActionsModule,
  NbStepperModule,
  NbRouteTabsetModule,
  NbSpinnerModule,
  NbSelectModule,
  NbOptionModule,
  NbDatepickerModule,
  NbDialogModule,
  NbTabsetModule,
  NbToggleModule,
  NbFormFieldModule,
  NbTreeGridModule,
  NbTooltipModule,
  NbRadioModule,
  NbIconModule
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';

// PrimeNG
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { AccordionModule } from 'primeng/accordion';

// Otros módulos
import { AngularSlickgridModule } from 'angular-slickgrid';
import { GalleryModule } from  'ng-gallery';//'@ngx-gallery/core';
 //import { LightboxModule } from 'ng-gallery/lightbox';//from '@ngx-gallery/lightbox';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalModule } from 'ngx-bootstrap/modal';


//Imports LOCALES

import { AppRoutingModule } from '../app-routing.module';
//import { AppComponent } from '../app.component';
import { LoginComponent } from '../login/login.component';
import { SpinnerComponent } from '../spinner/spinner.component';
import { HomeComponent } from '../home/home.component';
import { ConsultaInspeccionesComponent } from '../consulta-inspecciones/consulta-inspecciones.component';
import { GrupoTipoComponent } from '../grupo-tipo/grupo-tipo.component';
import { TipoComponent } from '../tipo/tipo.component';
import { OrigenComponent } from '../origen/origen.component';
import { SeveridadComponent } from '../severidad/severidad.component';
import { AreaComponent } from '../area/area.component';
import { DiscrepanciasActivasComponent } from '../discrepanciasActivas/discrepanciasActivas.component';
import { EntidadesComponent } from '../entidades/entidades.component';
import { ComponenteComponent } from '../componente/componente.component';
import { ClasificacionComponent } from '../clasificacion/clasificacion.component';
import { SnackBarComponent } from '../snack-bar/snack-bar.component';
import { PerfilesUsuarioComponent } from '../perfiles-usuario/perfiles-usuario.component';
import { DiscrepanciasSolucionadasComponent } from '../discrepancias-solucionadas/discrepancias-solucionadas.component';
import { OptionsReportesComponent } from '../options-reportes/options-reportes.component';
import { EditAveriaComponent } from '../edit-averia/edit-averia.component';
import { AreaComponenteComponent } from '../area-componente/area-componente.component';
import { DialogoGuardarDebitoComponent } from '../dialogo-guardar-debito/dialogo-guardar-debito.component';
import { DialogoGuardarSeguroComponent } from '../dialogo-guardar-seguro/dialogo-guardar-seguro.component';
import { DialogoActualizarDebitoComponent } from '../dialogo-actualizar-debito/dialogo-actualizar-debito.component';
import { DialogoActualizarSeguroComponent } from '../dialogo-actualizar-seguro/dialogo-actualizar-seguro.component';
import { CriteriosDeSimilitudComponent } from '../criterios-de-similitud/criterios-de-similitud.component';
import { GestionUsuariosComponent } from '../gestion-usuarios/gestion-usuarios.component';
import { SubUsuariosComponent } from '../gestion-usuarios/sub-usuarios/sub-usuarios.component';
import { OperadoresComponent } from '../operadores/operadores.component';
import { NuevoUsuarioComponent } from '../gestion-usuarios/nuevo-usuario/nuevo-usuario.component';
import { EditUsuarioComponent } from '../gestion-usuarios/edit-usuario/edit-usuario.component';
import { DatosUsuarioComponent } from '../datos-usuario/datos-usuario.component';
import { DialogoActualizarPasswordComponent } from '../dialogo-actualizar-password/dialogo-actualizar-password.component';
import { NuevoUsuarioOperadorComponent } from '../gestion-usuarios/nuevo-usuario-operador/nuevo-usuario-operador.component';
import { ChangePasswordComponent } from '../gestion-usuarios/change-password/change-password.component';
import { ValorizacionComponent } from '../valorizacion/valorizacion.component';
import { ClientesOperadoresComponent } from '../clientes-operadores/clientes-operadores.component';
import { SubUsuariosOperadorComponent } from '../gestion-usuarios-operador/sub-usuarios-operador/sub-usuarios-operador.component';
import { GestionUsuariosOperadorComponent } from '../gestion-usuarios-operador/gestion-usuarios-operador.component';
import { ConsultaUsuariosOperadorComponent } from '../consulta-usuarios-operador/consulta-usuarios-operador.component';
import { ClienteOperadoresAyudaPopupComponent } from '../cliente-operadores-ayuda-popup/cliente-operadores-ayuda-popup.component';
import { EditInspeccionAveriaComponent } from '../edit-inspeccion-averia/edit-inspeccion-averia.component';
import { ReparacionesAyudaPopupComponent } from '../reparaciones-ayuda-popup/reparaciones-ayuda-popup.component';
import { ReparacionesAyudaSegurosPopupComponent } from '../reparaciones-ayuda-seguros-popup/reparaciones-ayuda-seguros-popup.component';
import { InspeccionesRowdetailComponent } from '../consulta-inspecciones/inspecciones-rowdetail/inspecciones-rowdetail.component';
import { DialogoEliminarAveriasComponent } from '../dialogo-eliminar-averias/dialogo-eliminar-averias.component';
import { ModelosComponent } from '../modelos/modelos.component';
import { BuquesComponent } from '../buques/buques.component';
import { ReparacionesComponent } from '../reparaciones/reparaciones.component';
import { EliminarManualComponent } from '../eliminar-manual/eliminar-manual.component';
import { VinsBuquesComponent } from '../vins-buques/vins-buques.component';
import { VinsBuquesModifComponent } from '../vins-buques/vins-buques-modif/vins-buques-modif.component';
import { VinsBuquesConsultaComponent } from '../vins-buques/vins-buques-consulta/vins-buques-consulta.component';
import { VinsBuquesPopupValidExpoComponent } from '../vins-buques/vins-buques-popup-valid-expo/vins-buques-popup-valid-expo.component';
import { VinsBuquesDeleteOrDismissComponent } from '../vins-buques/vins-buques-delete-or-dismiss/vins-buques-delete-or-dismiss.component';
import { ManualesOperadoresComponent } from '../manuales-operadores/manuales-operadores.component';
import { PowerBIComponent } from '../Reportes/power-bi/power-bi.component';
import { ReportesInternosComponent } from '../Reportes/reportes-internos/reportes-internos.component';
//import { ConfirmPopupComponent } from '../discrepanciasActivas/confirm-popup/confirm-popup.component';
import { PopupConfirmacionComponent } from '../modelos/popup-confirmacion/popup-confirmacion.component';

//import locales

@NgModule({
  
  imports: [
    MatInputModule,
    CommonModule,
    GalleryModule,
    FormsModule,
    ReactiveFormsModule,
   
    //RouterModule,
    MatFormFieldModule,
    MatTableModule,
    FormsModule,
    LightboxModule,
    DragDropModule,
    DropdownModule,
    AngularSlickgridModule,
   // ImageViewerModule,
   AppRoutingModule,
//AppComponent,
LoginComponent,
SpinnerComponent,
HomeComponent,
ConsultaInspeccionesComponent,
GrupoTipoComponent,
TipoComponent,
OrigenComponent,
SeveridadComponent,
AreaComponent,
DiscrepanciasActivasComponent,
EntidadesComponent,
ComponenteComponent,
ClasificacionComponent,
SnackBarComponent,
PerfilesUsuarioComponent,
DiscrepanciasSolucionadasComponent,
OptionsReportesComponent,
EditAveriaComponent,
AreaComponenteComponent,
DialogoGuardarDebitoComponent,
DialogoGuardarSeguroComponent,
DialogoActualizarDebitoComponent,
DialogoActualizarSeguroComponent,
CriteriosDeSimilitudComponent,
GestionUsuariosComponent,
SubUsuariosComponent,
OperadoresComponent,
NuevoUsuarioComponent,
EditUsuarioComponent,
DatosUsuarioComponent,
DialogoActualizarPasswordComponent,
NuevoUsuarioOperadorComponent,
ChangePasswordComponent,
ValorizacionComponent,
ClientesOperadoresComponent,
SubUsuariosOperadorComponent,
GestionUsuariosOperadorComponent,
VinsBuquesModifComponent,
VinsBuquesConsultaComponent,
ConsultaUsuariosOperadorComponent,
ClienteOperadoresAyudaPopupComponent,
EditInspeccionAveriaComponent,
ReparacionesAyudaPopupComponent,
ReparacionesAyudaSegurosPopupComponent,
InspeccionesRowdetailComponent,
DialogoEliminarAveriasComponent,
ModelosComponent,
BuquesComponent,
ReparacionesComponent,
EliminarManualComponent,
VinsBuquesComponent,
VinsBuquesPopupValidExpoComponent,
VinsBuquesDeleteOrDismissComponent,
ManualesOperadoresComponent,
PowerBIComponent,
ReportesInternosComponent,
//ConfirmPopupComponent,
PopupConfirmacionComponent


  ],

  exports: [
    // Angular
    CommonModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
   // RouterModule,
  
    // Angular Material
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatSidenavModule,
    MatDividerModule,
    MatCardModule,
    MatTableModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatListModule,
    MatInputModule,
    MatTabsModule,
    MatButtonModule,
    MatSnackBarModule,
    MatDialogModule,
    MatStepperModule,
    MatCheckboxModule,
    MatProgressBarModule,
    // ImageViewerModule,
  
    // Nebular
    NbThemeModule,
    NbLayoutModule,
    NbSidebarModule,
    NbButtonModule,
    NbContextMenuModule,
    NbBadgeModule,
    NbAccordionModule,
    NbCheckboxModule,
    NbCardModule,
    NbMenuModule,
    NbListModule,
    NbUserModule,
    NbActionsModule,
    NbStepperModule,
    NbRouteTabsetModule,
    NbSpinnerModule,
    NbSelectModule,
    NbOptionModule,
    NbDatepickerModule,
    NbDialogModule,
    NbTabsetModule,
    NbToggleModule,
    NbFormFieldModule,
    NbTreeGridModule,
    NbTooltipModule,
    NbRadioModule,
    NbIconModule,
    NbEvaIconsModule,
  
    // PrimeNG
    DropdownModule,
    MultiSelectModule,
    AccordionModule,
  
    // Otros
    AngularSlickgridModule,
    GalleryModule,
    // LightboxModule,
    NgbModule,
    ModalModule,
  
    // Componentes
    SpinnerComponent,
    LoginComponent,
    HomeComponent,
    SubUsuariosOperadorComponent,
    EditUsuarioComponent,
    ChangePasswordComponent,
    NuevoUsuarioOperadorComponent,
    SubUsuariosComponent,
    VinsBuquesModifComponent,
    VinsBuquesConsultaComponent,
    NuevoUsuarioComponent,
    AppRoutingModule,
    //AppComponent,
    ConsultaInspeccionesComponent,
    GrupoTipoComponent,
    TipoComponent,
    OrigenComponent,
    SeveridadComponent,
    AreaComponent,
    DiscrepanciasActivasComponent,
    EntidadesComponent,
    ComponenteComponent,
    ClasificacionComponent,
    SnackBarComponent,
    PerfilesUsuarioComponent,
    DiscrepanciasSolucionadasComponent,
    OptionsReportesComponent,
    EditAveriaComponent,
    AreaComponenteComponent,
    DialogoGuardarDebitoComponent,
    DialogoGuardarSeguroComponent,
    DialogoActualizarDebitoComponent,
    DialogoActualizarSeguroComponent,
    CriteriosDeSimilitudComponent,
    GestionUsuariosComponent,
    OperadoresComponent,
    DatosUsuarioComponent,
    DialogoActualizarPasswordComponent,
    ValorizacionComponent,
    ClientesOperadoresComponent,
    GestionUsuariosOperadorComponent,
    ConsultaUsuariosOperadorComponent,
    ClienteOperadoresAyudaPopupComponent,
    EditInspeccionAveriaComponent,
    ReparacionesAyudaPopupComponent,
    ReparacionesAyudaSegurosPopupComponent,
    InspeccionesRowdetailComponent,
    DialogoEliminarAveriasComponent,
    ModelosComponent,
    BuquesComponent,
    ReparacionesComponent,
    EliminarManualComponent,
    VinsBuquesComponent,
    VinsBuquesPopupValidExpoComponent,
    VinsBuquesDeleteOrDismissComponent,
    ManualesOperadoresComponent,
    PowerBIComponent,
    ReportesInternosComponent,
    //ConfirmPopupComponent,
    PopupConfirmacionComponent
  ]
/*  
  exports: [
    // Angular
    CommonModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    // Angular Material
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatSidenavModule,
    MatDividerModule,
    MatCardModule,
    MatTableModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatListModule,
    MatInputModule,
    MatTabsModule,
    MatButtonModule,
    MatSnackBarModule,
    MatDialogModule,
    MatStepperModule,
    MatCheckboxModule,
    MatProgressBarModule,
  //  ImageViewerModule,
    // Nebular
    NbThemeModule,
    NbLayoutModule,
    NbSidebarModule,
    NbButtonModule,
    NbContextMenuModule,
    NbBadgeModule,
    NbAccordionModule,
    NbCheckboxModule,
    NbCardModule,
    NbMenuModule,
    NbListModule,
    NbUserModule,
    NbActionsModule,
    NbStepperModule,
    NbRouteTabsetModule,
    NbSpinnerModule,
    NbSelectModule,
    NbOptionModule,
    NbDatepickerModule,
    NbDialogModule,
    NbTabsetModule,
    NbToggleModule,
    NbFormFieldModule,
    NbTreeGridModule,
    NbTooltipModule,
    NbRadioModule,
    NbIconModule,
    NbEvaIconsModule,

    // PrimeNG
    DropdownModule,
    MultiSelectModule,
    AccordionModule,
    // Otros
    AngularSlickgridModule,
    GalleryModule,
    // LightboxModule,
    NgbModule,
    ModalModule,
    SpinnerComponent,
    LoginComponent,
    HomeComponent,
    SubUsuariosOperadorComponent,
    EditUsuarioComponent,
    ChangePasswordComponent,
    NuevoUsuarioOperadorComponent,
    SubUsuariosComponent,
    VinsBuquesModifComponent,
    VinsBuquesConsultaComponent,
    NuevoUsuarioComponent,
    
    
  ]
    */

})
export class SharedModule { }
